import { saveProgress } from '@brainstud/react-tbl/features/account/store'

/* -------------------------------------------------- */

export const loadProgressSuccess = payload => {
  return { type: 'NAVIGATION_LOAD_PROGRESS_SUCCESS', payload }
}

export const loadProgress = data => {
  return (dispatch, getState) => {
    if (!Object.values(data)[0]) {
      // Create progress if user start for the first time

      const { navigation, chapters } = getState()
      const progress = navigation.list.allIds.reduce((acc, id) => {
        const item = navigation.list.byId[id]

        const progressItem = {
          progress: 0,
          total: 0,
          status: 'active', //config.linearMode ? 'locked' : 'active',
        }

        switch (item.type) {
          case 'page':
          case 'quiz':
          case 'endtest':
            progressItem.total = 1
            break

          case 'chapter':
            const chapter = Object.values(chapters.chapters.byId).find(chpt => chpt.id === item.chapterId)
            progressItem.total = chapter.lessons.length

            if (chapter.summary) progressItem.total += 1
            break;

          default:
        }

        acc[item.id] = progressItem

        return acc
      }, {})

      dispatch(loadProgressSuccess(progress))
    } else {
      dispatch(loadProgressSuccess(data))
    }
  }
}

/* -------------------------------------------------- */

export const setProgressSuccess = payload => {
  return { type: 'NAVIGATION_SET_PROGRESS_SUCCESS', payload }
}

export const setProgress = params => {
  return (dispatch, getState) => {
    dispatch(setProgressSuccess(params))
    dispatch(saveProgress())
  }
}

/* -------------------------------------------------- */
